<template>
  <v-expansion-panel>
    <AppBorderedSection :sectionNumber="sectionNumber">
      <v-expansion-panel-header class="pa-0"
        ><div class="font-weight-bold">
          <slot name="title"></slot></div
      ></v-expansion-panel-header>
      <v-expansion-panel-content class="pa-0">
        <slot name="filters"></slot>
      </v-expansion-panel-content>
    </AppBorderedSection>
  </v-expansion-panel>
</template>

<script>
import AppBorderedSection from "@/components/AppBorderedSection.vue";

export default {
  props: {
    sectionNumber: { type: Number, required: true }
  },
  components: {
    AppBorderedSection
  }
};
</script>

<style>
.v-expansion-panel::before {
  box-shadow: none !important;
}
.v-expansion-panel::after {
  border: none !important;
}
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.v-expansion-panel--active
  .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
  .v-icon {
  transform: rotate(-180deg);
}
</style>